var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnitedKingdom1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "united-kingdom 1",
    clipPath: "url(#clip0_1626_52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "United Kingdom"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 6C12 9.31275 9.31525 11.9985 6.00275 12H5.938C5.64715 11.997 5.3569 11.973 5.0695 11.9283C4.83416 11.8919 4.60123 11.8413 4.372 11.7768C3.11344 11.4216 2.0053 10.6651 1.21613 9.6224C0.426955 8.57966 -7.04577e-05 7.30771 8.71973e-09 6C8.71973e-09 2.68675 2.6855 2.39367e-06 6 2.39367e-06H6.00275C6.81902 -0.000727829 7.62681 0.165623 8.37638 0.488813C9.12595 0.812003 9.80143 1.28519 10.3613 1.87925C11.4142 2.99287 12.0006 4.46744 12 6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.48576 4.21558V4.48558H3.61351L1.16351 2.44833C1.31495 2.24233 1.47946 2.04626 1.65601 1.86133L4.48576 4.21558Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.8442 2.45884L8.40847 4.48384H7.51422V4.23334L10.3537 1.87109L10.3612 1.87884C10.5249 2.05138 10.678 2.23363 10.8197 2.42459L10.8442 2.45884Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.48576 7.51367V7.78367L1.65601 10.1384C1.63101 10.1134 1.60601 10.0864 1.58251 10.0602C1.43365 9.89844 1.29386 9.7286 1.16376 9.55142L3.61376 7.51367H4.48576Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.8445 9.54017C10.6936 9.74633 10.5298 9.94265 10.354 10.1279L7.51422 7.76542V7.51367H8.40847L10.8445 9.54017Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M2.39625 4.48613H0.192749C0.317931 4.00606 0.5027 3.54355 0.742749 3.10938L2.39625 4.48613Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M2.3465 7.51367L0.724999 8.86217C0.49328 8.43605 0.314537 7.98319 0.192749 7.51367H2.3465Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M4.48573 8.7832V11.8082C4.44773 11.7985 4.41073 11.7882 4.37198 11.7775C3.58579 11.5561 2.8533 11.1759 2.21973 10.6605L4.48573 8.7832Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M4.48573 0.193359V3.17086L2.25348 1.31386C2.91038 0.787373 3.67106 0.405543 4.48573 0.193359Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M9.78072 1.34161L7.51422 3.22036V0.193359L7.54847 0.202109C8.36475 0.41986 9.12556 0.808236 9.78072 1.34161Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M11.8072 4.48662H9.65723L11.275 3.14062C11.5065 3.56598 11.6852 4.01798 11.8072 4.48662Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M9.8 10.6446C9.13148 11.1928 8.35208 11.5895 7.5155 11.8074V8.74414L9.8 10.6446Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M11.8073 7.51367C11.6881 7.97185 11.5148 8.41421 11.291 8.83142L9.70728 7.51367H11.8073Z",
    fill: "#012169"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M12 5.93725V6.057C11.9974 6.33677 11.9754 6.61602 11.9342 6.89275H6.89275V11.934C6.61776 11.975 6.34027 11.9971 6.06225 12H5.93725C5.65914 11.9971 5.38155 11.975 5.1065 11.9338V6.89275H0.066C0.0249756 6.61742 0.00292365 6.3396 0 6.06125C0 6.022 0 5.9825 0 5.943C0.00258632 5.66315 0.0245556 5.38381 0.06575 5.107H5.10725V0.066C5.36904 0.026861 5.6331 0.00481433 5.89775 0L6.09125 0C6.34381 0.003611 6.5959 0.0231498 6.846 0.0585L6.89275 0.0655V5.107H11.934C11.975 5.38191 11.9971 5.65931 12 5.93725Z",
    fill: "#C8102E"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1626_52"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedKingdom1);
export default __webpack_public_path__ + "static/media/united-kingdom 1.c13e3ee88614e06bf1be8615f5a31b23.svg";
export { ForwardRef as ReactComponent };